let addParams = require('../../actions/custom-order/additional-parameters');
let utils = require('../../actions/utils');
let { calcPriceGroup } = require('../groups/order');
let analytics = require('../../actions/analytics');
const form = require('../form');
let customOrder = require('../../actions/custom-order');

module.exports = {
    selectDate (name, isFrom) {
        let setDateAction = isFrom ? addParams.changeDateDatepickerFrom : addParams.changeDateDatepickerTo;
        return [
            addParams.setExportDateTimeColumnIsChecked,
            setDateAction,
            utils.togglePopup(name),
            ...calcPriceGroup,
            analytics.argsValueEvent({ category: 'date_of_company', action: 'see' })
        ];
    },

    clearDatepicker (path) {
        return [
            utils.unset(path),
            ...calcPriceGroup
        ];
    },

    setGreederColumnIsChecked: [
        addParams.setGreederColumnIsChecked,
        customOrder.setFilterValuesChanged
    ],

    setGreederColumnSource: [
        addParams.setGreederColumnSource,
        customOrder.setFilterValuesChanged
    ],

    setAllGreederColumns: [
        addParams.setAllGreederColumnIsChecked,
        customOrder.setFilterValuesChanged
    ],

    setExportColumnIsChecked: [
        addParams.setExportColumnIsChecked,
        addParams.unsetRelatedParams,
        utils.setArg('metricEventPrefix', 'checkbox_optional_column_'),
        [
            analytics.fillEventArgsFromAdditionalParamSet,
            {
                filled: [analytics.raiseArgsValueEvent],
                noEvent: []
            }
        ],
        ...calcPriceGroup
    ],

    setExportColumnIsMustBeFilled: [
        addParams.setExportColumnIsMustBeFilled,
        utils.setArg('metricEventPrefix', 'checkbox_availability_'),
        [
            analytics.fillEventArgsFromAdditionalParamSet,
            {
                filled: [analytics.raiseArgsValueEvent],
                noEvent: []
            }
        ],
        ...calcPriceGroup
    ],

    toggleOnlyHeadCards: [
        utils.toggleBool(['order', 'addParams', 'onlyHeadCards']),
        analytics.argsValueEvent({ category: 'checkbox_only_head_cards', action: 'input' }),
        ...calcPriceGroup
    ],

    // сейчас этот инпут текста только для одного единственного столбца "Площади"
    // если столбцов будет больше надо будет сделать по-нормальному
    inputText: [
        ...form.inputAndValidateText,
        addParams.setExportAreaColumnIsChecked,
        ...calcPriceGroup
    ],

    blurText: [
        ...form.blurText,
        ...calcPriceGroup
    ],

    toggleArchiveInn: [
        utils.toggleBool(['order', 'addParams', 'includeArchiveInn']),
        ...calcPriceGroup
    ]
};



// WEBPACK FOOTER //
// ./signals/custom-order/additional-parameters.js